export enum RouteName {
  Dashboard = 'Dashboard',
  CreateReport = 'CreateReport',
  ActiveReports = 'ActiveReports',
  ConsolidatedReports = 'ConsolidatedReports',
  HistoricReports = 'HistoricReports',
  ReportPage = 'ReportPage',
  UserProfile = 'UserProfile',
  ChildOrganizationsList = 'ChildOrganizationsList',
  ChildOrganizationsActiveReports = 'ChildOrganizationsActiveReports',
  ChildOrganizationsHistoricReports = 'ChildOrganizationsHistoricReports',
  UnauthorizedLayout = 'UnauthorizedLayout',
  DefaultLayout = 'DefaultLayout',
  AutomaticProcessingCodes = 'AutomaticProcessingCodes',
  ReportTypeSchedules = 'ReportTypeSchedules',
  BudgetUsers = 'BudgetUsers',
  Municipalities = 'Municipalities',
  TreasuryBranches = 'TreasuryBranches',
  ReportTypes = 'ReportTypes',
  ReportTypePeriodStatistics = 'ReportTypePeriodStatistics',
  OrganizationStatistics = 'OrganizationStatistics',
  UserInfo = 'UserInfo',
  UserApproval = 'UserApproval',
  UserManagement = 'UserManagement',
  UserNotifications = 'UserNotifications',
  UserRegistrations = 'UserRegistrations',
  ExplicitHierarchies = 'ExplicitHierarchies',
  UserRegistrationChange = 'UserRegistrationChange',
  CreateUser = 'CreateUser',
  ReportDetails = 'ReportDetails',
  ReportForms = 'ReportForms',
  ReportImport = 'ReportImport',
  ReportDocuments = 'ReportDocuments',
  ReportActivities = 'ReportActivities',
  ReportNotes = 'ReportNotes',
  ReportValidation = 'ReportValidation',
  FinancialReports = 'FinancialReports',
  Registration = 'Registration',
  InitialLogin = 'InitialLogin',
  ResetPassword = 'ResetPassword',
  ForgotPassword = 'ForgotPassword',
  Activate = 'Activate',
  Home = 'Home'
};

export type ChildOrganizationRoute = RouteName.ChildOrganizationsList | RouteName.ChildOrganizationsActiveReports | RouteName.ChildOrganizationsHistoricReports;

export const ChildOrganizationsRouteNames = [
  RouteName.ChildOrganizationsList,
  RouteName.ChildOrganizationsActiveReports,
  RouteName.ChildOrganizationsHistoricReports
] as const;
